/*------------------------------------*\
    NAV
\*------------------------------------*/
class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        /*------------------------------------*\
            Main nav
        \*------------------------------------*/
        const toggle = document.querySelector('.js-nav-toggle');
        const app = document.querySelector('.js-app');
        const body = document.querySelector('body');

        toggle.addEventListener('click', evt => {
            evt.preventDefault();
            toggle.classList.toggle('is-active');
            app.classList.toggle('is-active');
            body.classList.toggle('is-no-scroll');
        });

        /*------------------------------------*\
            Nav dropdown
        \*------------------------------------*/
        const dropdowns = document.querySelectorAll('.js-site-nav-item--has-dropdown');

        Array.from(dropdowns).forEach(elem => {
            let trigger = elem.querySelector('.js-site-nav-dropdown-trigger');
            let dropdown = elem.querySelector('.js-site-nav-dropdown');

            trigger.addEventListener('click', evt => {
                evt.preventDefault();

                dropdown.classList.toggle('is-active');
                trigger.classList.toggle('is-dropdown-active');
            });

            document.addEventListener('click', evt => {
                if (!elem.contains(evt.target)) {
                    dropdown.classList.remove('is-active');
                    trigger.classList.remove('is-dropdown-active');
                }
            });
        });
    }
}

export default Nav;
